var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwodice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250.491 250.491",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.491,85.341c-2.761,0-5,2.238-5,5v3c0,2.762,2.239,5,5,5s5-2.238,5-5v-3C250.491,87.579,248.252,85.341,245.491,85.341 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.571,0.001h-103.49c-13.741,0-24.92,11.179-24.92,24.92v72.243H24.917C11.178,97.164,0,108.342,0,122.082v16.259 c0,2.762,2.239,5,5,5c2.761,0,5-2.238,5-5v-16.259c0-8.226,6.692-14.918,14.917-14.918h103.491c8.225,0,14.917,6.692,14.917,14.918 v103.491c0,8.226-6.692,14.917-14.917,14.917H24.917c-8.226,0-14.917-6.691-14.917-14.917v-64.232c0-2.762-2.239-5-5-5 c-2.761,0-5,2.238-5,5v64.232c0,13.739,11.178,24.917,24.917,24.917h103.491c13.74,0,24.917-11.178,24.917-24.917v-72.242h72.245 c13.741,0,24.92-11.18,24.92-24.921v-19.736c0-2.762-2.239-5-5-5s-5,2.238-5,5v19.736c0,8.228-6.693,14.921-14.92,14.921h-72.245 v-21.249c0-13.74-11.178-24.918-24.917-24.918h-21.248V24.921c0-8.227,6.693-14.92,14.92-14.92h103.49 c8.227,0,14.92,6.693,14.92,14.92v49.753c0,2.762,2.239,5,5,5s5-2.238,5-5V24.921C250.491,11.179,239.311,0.001,225.571,0.001z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.496,
    cy: 136.527,
    r: 9.749
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.496,
    cy: 173.577,
    r: 9.749
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.496,
    cy: 210.627,
    r: 9.749
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.996,
    cy: 136.527,
    r: 9.749
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.996,
    cy: 173.577,
    r: 9.749
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.996,
    cy: 210.627,
    r: 9.749
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.826,
    cy: 76.665,
    r: 9.749
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwodice);
export default __webpack_public_path__ + "static/media/twodice.d4a19debb0d39227bf791792a5173bba.svg";
export { ForwardRef as ReactComponent };